import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import SoftBadge from 'components/common/SoftBadge';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import { Card, Col, Form, Row } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import { Link } from 'react-router-dom';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox';
import FooterPaginacionOrdenes from './FooterPaginacionOrdenes'
import akasiaLogo from "assets/img/illustrations/akasia.png";
import PropTypes from 'prop-types';

const TablaOrdenes = ({
    ordenes,
    vendedores,
    vendedorID,
    setVendedorID,
    dateQuarter,
    FilterEstatus,
    setFilterEstatus,
    tipoReporte,
    setTipoReporte,
    pageSize,
    setPageSize,
    totalRecords,
    pageNumber,
    setPageNumber,
    idCatTipoUsuario,
    ObtenerOrden,
    searchFilter,
    onSearchChange,
    ordenamiento,
    setSortOrdenamiento
}) => {

    const handleSort = (ordenAscDesc) => {
        let nuevoOrden = `${ordenAscDesc} ASC`;

        if (ordenamiento === `${ordenAscDesc} ASC`) {
            nuevoOrden = `${ordenAscDesc} DESC`;
        }

        setSortOrdenamiento(nuevoOrden);
        setPageNumber(1);
    };

    const columnsOrdenes = [
        {
            accessor: 'iNumPagosNoValidados',
            Header: '',
            cellProps: {
                className: 'py-2'
            },
            Cell: rowData => {
                const { iNumPagosNoValidados, idOrden, bComentario, bIsActive, bIsArchivoAdjunto, dFechaOrden, dFechaPrimerPago } = rowData.row.original;
                return (
                    <>
                        {bIsActive == 0 &&
                            <img title="Orden Eliminada" src="/img/noactivo.png"></img>
                        }
                        {iNumPagosNoValidados > 0 &&
                            <Link to={"/ordenes/detalle/" + idOrden}>
                                <img title="Hay pagos sin validar..." src="/img/advertencia20.png"></img>
                            </Link>
                        }
                        {iNumPagosNoValidados == 0 &&
                            <img title="Validado" src="/img/activo.png"></img>
                        }
                        {bIsArchivoAdjunto == 1 &&
                            <img title="Archivo Adjunto" src="/img/archivo20.png"></img>
                        }
                        {bComentario == 1 &&
                            <img title="Hay comentarios" src="/img/comentario20.png"></img>
                        }
                        {dFechaPrimerPago < dFechaOrden &&
                            <Link to={"/ordenes/detalle/" + idOrden}>
                                <img title="Hay un error en este pago" src="/img/error20.png"></img>
                            </Link>
                        }
                    </>
                );
            }
        },
        {
            accessor: 'idOrden',
            disableSortBy: true,
            Header: () => <span onClick={() => handleSort('idOrden')} style={{ cursor: 'pointer', display: 'block', width: '100%' }}>Orden</span>,
            cellProps: {
                className: 'py-2'
            },
            Cell: rowData => {
                const { idOrden, bIsActive } = rowData.row.original;
                return (
                    <>
                        <Link to={"/ordenes/detalle/" + idOrden} target="_blank">
                            <strong className={classNames({
                                "text-danger": bIsActive == false,
                            })}># {idOrden}</strong>
                        </Link>
                    </>
                );
            }
        },
        {
            accessor: 'vNombreCliente',
            disableSortBy: true,
            Header: () => <span onClick={() => handleSort('vNombreCliente')} style={{ cursor: 'pointer', display: 'block', width: '100%' }}>Cliente</span>,
            cellProps: {
                className: 'py-2'
            },
            Cell: rowData => {
                const { idClienteAkasia, vNombreCliente, vEmail, bIsActive, bIsRecompra, bIsDistribucion } = rowData.row.original;
                return (
                    <>
                        <Link to={"/clientes/detalle/" + idClienteAkasia}>
                            <strong className={classNames({
                                "text-danger": bIsActive == false,
                            })}>
                                {
                                    bIsDistribucion == null ? "" :
                                        bIsDistribucion == 1 ? "🎖️ " :
                                            bIsDistribucion == 0 ? <img width="15" src={akasiaLogo}></img> :
                                                ""
                                } {bIsRecompra && "♻ "} {vNombreCliente}</strong> <br />
                        </Link>
                        <span className={classNames({
                            "text-danger": bIsActive == false,
                            "text-lowercase": true
                        })} >{vEmail}</span>
                    </>
                );
            }
        },
        {
            accessor: 'dFechaVenta',
            disableSortBy: true,
            Header: () => <span onClick={() => handleSort('dFechaVenta')} style={{ cursor: 'pointer', display: 'block', width: '100%' }}>Fecha venta</span>,
        },
        {
            accessor: 'vUsuario',
            disableSortBy: true,
            Header: () => <span onClick={() => handleSort('vUsuario')} style={{ cursor: 'pointer', display: 'block', width: '100%' }}>Vendedor</span>,
            Cell: rowData => {
                const { vUsuario } = rowData.row.original;
                return (
                    <>
                        {vUsuario}
                    </>
                );
            }
        },
        {
            accessor: 'status',
            disableSortBy: true,
            Header: () => <span onClick={() => handleSort('status')} style={{ cursor: 'pointer', display: 'block', width: '100%' }}>Status</span>,
            headerProps: {
                className: 'text-center'
            },
            cellProps: {
                className: 'fs--1'
            },
            Cell: rowData => {
                const { bIsPagada, bIsActive } = rowData.row.original;
                return (
                    <>
                        {bIsActive == 1 &&
                            <SoftBadge
                                pill
                                bg={classNames({
                                    success: bIsPagada === true,
                                    warning: bIsPagada === false,
                                })}
                                className="d-flex flex-center"
                            >
                                <p className="mb-0">
                                    {bIsPagada === true && 'Pagada'}
                                    {bIsPagada === false && 'No pagada'}
                                </p>
                                <FontAwesomeIcon
                                    icon={classNames({
                                        check: bIsPagada === true,
                                        redo: bIsPagada === 'processing',
                                        stream: bIsPagada === false,
                                        ban: bIsPagada === 'onhold'
                                    })}
                                    transform="shrink-2"
                                    className="ms-1"
                                />
                            </SoftBadge>}
                        {bIsActive == 0 &&
                            <SoftBadge
                                pill
                                bg="danger"
                                className="d-flex flex-center"
                            >
                                <p className="mb-0">
                                    Cancelada
                                </p>
                                <FontAwesomeIcon
                                    icon="ban"
                                    transform="shrink-2"
                                    className="ms-1"
                                />
                            </SoftBadge>}
                    </>
                );
            }
        },
        {
            accessor: 'dTotal',
            disableSortBy: true,
            Header: () => <span onClick={() => handleSort('dTotal')} style={{ cursor: 'pointer', display: 'block', width: '100%' }}>Total</span>,
            Cell: rowData => {
                const { dTotal } = rowData.row.original;
                return (
                    <>
                        <span className="text-end fs--1 fw-medium py-2">${parseFloat(dTotal).toLocaleString("es-MX", {
                            maximumFractionDigits: 2,
                            minimumFractionDigits: 2
                        })}</span>
                    </>
                );
            }
        },
        {
            accessor: 'vMoneda',
            disableSortBy: true,
            Header: () => <span onClick={() => handleSort('vMoneda')} style={{ cursor: 'pointer', display: 'block', width: '100%' }}>Moneda</span>,
            Cell: rowData => {
                const { vMoneda, dTipoCambio } = rowData.row.original;
                return (
                    <>
                        <span>
                            <span>{vMoneda}</span>
                            <span className="fw-bold">{(vMoneda == 'USD' ? " T.C. " + dTipoCambio : "")}</span>
                        </span>
                    </>
                );
            }
        },
        {
            accessor: '',
            disableSortBy: true,
            Header: 'Forma Pago',
            Cell: rowData => {
                const { vClave, vDescripcionFormaPago } = rowData.row.original;
                return (
                    <>
                        <span>{vClave}   {vDescripcionFormaPago}</span>
                    </>
                );
            }
        }
    ];

    return (
        <AdvanceTableWrapper
            columns={columnsOrdenes}
            data={ordenes}
            sortable={true}
            pagination
            perPage={30}
        >
            <Card className="mb-3">
                <Card.Header>
                    <Row>
                        <Col xs={12} sm={6} md={6} lg={3}>
                            <span><Form.Label className="text-700 m-0">Mes</Form.Label> <br /></span>
                            <DatePicker
                                selected={dateQuarter}
                                onChange={(date) => {
                                    sessionStorage.setItem("selectMes", date);
                                    setPageNumber(1);
                                    ObtenerOrden(vendedorID, date, 1, pageSize, searchFilter, ordenamiento);
                                }}
                                dateFormat="MMMM yyyy - QQQ"
                                className="form-control w-100 m-0"
                                showMonthYearPicker
                            />
                        </Col>

                        <Col xs={12} sm={6} md={6} lg={3} className="align-items-center mb-1">
                            <Form.Label className="text-700 m-0">Vendedores</Form.Label>
                            <Form.Select
                                size="sm"
                                aria-label="Default select"
                                className="form-control m-0"
                                value={vendedorID}
                                onChange={(e) => {
                                    setVendedorID(e.target.value);
                                    sessionStorage.setItem("selectIDUsuario", e.target.value);
                                    setPageNumber(1);
                                }}
                                disabled={idCatTipoUsuario != 1}
                            >
                                <option value="">Todos los vendedores</option>
                                {vendedores.map((vendedor, index) => {
                                    return (<option key={index} value={vendedor.idUsuario}>{vendedor.vNombre} {vendedor.vApellidos}</option>);
                                })}
                            </Form.Select>
                        </Col>

                        <Col xs={12} sm={6} md={6} lg={3} className="align-items-center mb-1">
                            <Form.Label className="text-700 m-0">Estatus</Form.Label>
                            <Form.Select
                                size="sm"
                                aria-label="Default select"
                                className="form-control m-0"
                                value={FilterEstatus}
                                onChange={(e) => {
                                    setFilterEstatus(e.target.value);
                                    setPageNumber(1);
                                }}
                            >
                                <option value="-1">TODOS</option>
                                <option value="1">Pagadas</option>
                                <option value="0">No Pagadas</option>
                            </Form.Select>
                        </Col>

                        <Col xs={12} sm={6} md={6} lg={3} className="align-items-center mb-1">
                            <Form.Label className="text-700 m-0">Tipo de reporte</Form.Label>
                            <Form.Select
                                size="sm"
                                aria-label="Default select"
                                className="form-control m-0"
                                value={tipoReporte}
                                onChange={(e) => {
                                    setTipoReporte(Number(e.target.value));
                                    setPageNumber(1);
                                }}
                            >
                                <option value="0">ÓRDENES</option>
                                <option value="1">DETALLE DE ÓRDEN</option>
                            </Form.Select>
                        </Col>

                        <Col sm={8} lg={4} xs={12} className="mt-2" >
                            <AdvanceTableSearchBox
                                globalFilter={searchFilter}
                                setGlobalFilter={(val) => {
                                    onSearchChange(val);
                                    setPageNumber(1);
                                    ObtenerOrden(vendedorID, dateQuarter, 1, pageSize, val, ordenamiento);
                                }}
                                placeholder="Buscar orden..."
                            />
                        </Col>
                    </Row>
                </Card.Header>
                <Card.Body className="p-0">
                    <AdvanceTable
                        table
                        headerClassName="bg-200 text-900 text-nowrap align-middle"
                        rowClassName="align-middle white-space-nowrap"
                        tableProps={{
                            size: 'sm',
                            striped: true,
                            className: 'fs--2 mb-0 overflow-hidden'
                        }}
                    />
                </Card.Body>
                <Card.Footer>
                    <FooterPaginacionOrdenes
                        pageSize={pageSize}
                        totalRecords={totalRecords}
                        pageNumber={pageNumber}
                        page={ordenes}
                        onPageSizeChange={({ target }) => {
                            setPageSize(Number(target.value));
                            setPageNumber(1);
                        }}
                        onNextPage={() => setPageNumber(pageNumber + 1)}
                        onPreviousPage={() => setPageNumber(pageNumber - 1)}
                    />
                </Card.Footer>
            </Card>
        </AdvanceTableWrapper>
    );
};

TablaOrdenes.propTypes = {
    ordenes: PropTypes.array.isRequired,
    vendedores: PropTypes.array.isRequired,
    vendedorID: PropTypes.string,
    setVendedorID: PropTypes.func.isRequired,
    dateQuarter: PropTypes.instanceOf(Date).isRequired,
    setDateQuarter: PropTypes.func.isRequired,
    FilterEstatus: PropTypes.string.isRequired,
    setFilterEstatus: PropTypes.func.isRequired,
    tipoReporte: PropTypes.number.isRequired,
    setTipoReporte: PropTypes.func.isRequired,
    cargando: PropTypes.bool.isRequired,
    pageSize: PropTypes.number.isRequired,
    setPageSize: PropTypes.func.isRequired,
    totalRecords: PropTypes.number.isRequired,
    pageNumber: PropTypes.number.isRequired,
    setPageNumber: PropTypes.func.isRequired,
    idCatTipoUsuario: PropTypes.number,
    ObtenerOrden: PropTypes.func.isRequired,
    searchFilter: PropTypes.string.isRequired,
    setSearchFilter: PropTypes.func.isRequired,
    onSearchChange: PropTypes.func.isRequired,
    ordenamiento: PropTypes.string.isRequired,
    setSortOrdenamiento: PropTypes.func.isRequired
};

export default TablaOrdenes;